export const OrganizationalContainerSources = {
  DefaultOrganizationalContainerSource: 'tswp-carrier-b2b:DefaultOrganizationalContainerSource'
};
